import { render } from "./TopPicks.vue?vue&type=template&id=706ccc3e"
import script from "./TopPicks.vue?vue&type=script&lang=js"
export * from "./TopPicks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__